/**
 * @fileoverview 本地缓存工具
 */
export default {
    getData: function (name) {
        var data = '';
        try {
            if (window.localStorage) {
                data = window.localStorage[name];
            }
        }
        catch (e) {
            window.console.log(e);
        }
        return data;
    },
    setData: function (name, value) {
        if (name === 'undefined' || name === undefined) {
            return;
        }
        try {
            if (window.localStorage) {
                window.localStorage[name] = value;
            }
        }
        catch (e) {
            window.console.log(e);
        }
    },
    delData: function (name) {
        try {
            if (window.localStorage) {
                window.localStorage.removeItem(name);
            }
        }
        catch (e) {
            window.console.log(e);
        }
    },
};
